import Marionette from "backbone.marionette";
import Moment from "moment";

import ParametersModel from "models/parametersModel.js";
var parametersModel = new ParametersModel();

/////Vistas
import ResumenView from "views/report/reportResumenView.ejs";
import DetalladosView from "views/report/reportDetalladosView.ejs";
import ResumenRegion from "views/report/regionResumenView.ejs";
import DetalladosRegion from "views/report/regionDetalladosView.ejs";
import LineTpl from "views/report/formLine.ejs";

import ReportModel from "models/reportModel.js";

import CSS from "views/report/report.css";

import PaginationView from "views/pagination/pagination.js";

import S from "session/session.js";
import T from "session/token.js";

var bootbox = require("bootbox");

export default Marionette.LayoutView.extend({

    initialize: function(data) {
        $('.content-wrapper').css({ 'margin-left': '230px' });

        this.model = new ReportModel();
        this.table = data.table;
        this.type = ""; // Default empty
        this.report = ""; // Default empty
        this.listenTo(this.model, "sync", this.applyView.bind(this));
        this.listenTo(S.mApp, "stopPendingPDF", this.stopPendingPDF);
    },
    filtro: 0,
    render: function() {

        $("#loaderContainer").show();
        parametersModel.fetch({
            data: {
                instanceId: S.instanceId
            },
            beforeSend: T.useToken,
            success: function() {
                var report;

                switch (this.table) {
                    case 'report_detallados':
                        this.template = DetalladosView;
                        this.regionView = DetalladosRegion;
                        break;

                    case 'report_resumen':
                        this.template = ResumenView;
                        this.regionView = ResumenRegion;
                        break;
                }

                this.model.fetch({
                    data: {
                        instanceId: S.instanceId,
                        page: 1,
                        report: this.report,
                        start: true
                    },
                    beforeSend: T.useToken,
                    success: function() {
                        this.$el.html(this.template({
                            titlePage: "Detallados",
                            lang: _.extend(this.model.lang, S.userInfo.attributes.lang),
                            params: parametersModel.toJSON(),
                            fecha_start: this.model.attributes.fecha_start,
                            fecha_end: this.model.attributes.fecha_end
                        }));
                    }.bind(this)
                });

            }.bind(this)
        });

    },
    applyView: function() {

        var thisAlias = this;

        // Check for pending downloads > navbar
        if (($("#generatedPDF").is(':visible') || $("#generatingPDF").is(':visible') || !this.report)) {
            $('.exportPDFButton').addClass('hidden');
            $('#exportPDFDisabled').removeClass("hidden");
        }


        var cuentas = [];
        for (var a in parametersModel.attributes.amortizaciones) {
            var item = parametersModel.attributes.amortizaciones[a];
            cuentas[item.item] = item.cc_inmobil;
            cuentas[item.epigraph] = item.cc_encurso;
        }


        var tipoAdquisicion = [];
        for (var a in parametersModel.attributes.adquisiciones) {
            var item = parametersModel.attributes.adquisiciones[a];
            tipoAdquisicion[item.word] = item.translation;
        }


        var listEpigrafes = [];
        for (var epi in parametersModel.attributes.epigraphs) {
            var itemepi = parametersModel.attributes.epigraphs[epi];
            listEpigrafes[itemepi.word] = itemepi.translation;
        }

        // Remove active menu items
        $(".sidebar li").removeClass("active");
        $(".sidebar li > ul").removeClass("active menu-open");
        var subReport = this.table.toUpperCase();
        // Add active menu items
        $("#" + subReport).parents("ul").addClass("active menu-open");
        $("#" + subReport).parents("li").addClass("active");

        switch (this.table) {
            case 'report_detallados':
                this.template = DetalladosView;
                this.regionView = DetalladosRegion;

                $("#regionData").html(this.regionView({
                    type: this.type,
                    report: this.report,
                    attributes: this.model.attributes,
                    lang: _.extend(this.model.lang, S.userInfo.attributes.lang),
                    cuentas: cuentas,
                    tipoAdquisicion: tipoAdquisicion,
                    listEpigrafes: listEpigrafes
                }));

                //Date controls
                $("#rangofechasStart").datetimepicker({
                    format: 'DD/MM/YYYY',
                    allowInputToggle: true,
                });
                $("#rangofechasEnd").datetimepicker({
                    format: 'DD/MM/YYYY',
                    allowInputToggle: true,
                    useCurrent: false
                });
                $("#rangofechasStart").on("dp.change", function(e) {
                    $('#rangofechasEnd').data("DateTimePicker").minDate(e.date);
                });
                $("#rangofechasEnd").on("dp.change", function(e) {
                    $('#rangofechasStart').data("DateTimePicker").maxDate(e.date);
                });
                break;

            case 'report_resumen':

                this.template = ResumenView;
                this.regionView = ResumenRegion;

                $("#regionData").html(this.regionView({
                    type: this.type,
                    report: this.report,
                    attributes: this.model.attributes,
                    lang: _.extend(this.model.lang, S.userInfo.attributes.lang),
                    cuentas: cuentas,
                    tipoAdquisicion: tipoAdquisicion,
                    listEpigrafes: listEpigrafes
                }));
                break;
        }

        $("#loaderContainer").hide();
        this.adjustForm();
        $("#wrapper").height(window.innerHeight);
        this.model.clear();
    },
    events: {
        "click #resumenCuentas": "resumenCuentas",
        "click #resumenEpigraph": "resumenEpigraph",
        "click #resumenPatrimonio": "resumenPatrimonio",
        "click #detalleCuentas": "detalleCuentas",
        "click #detalleEpigraph": "detalleEpigraph",
        "click #detallePatrimonio": "detallePatrimonio",
        "click #detalleAlta": "detalleAlta",
        "click #detalleBaja": "detalleBaja",
        "click #cancel": "cancel",

        "click #exportPDF": "exportPDF",
        "click #exportPDFDetail": "exportPDFDetail",

        "click #exportEXCEL": "exportEXCEL",
        "click #exportEXCELDetail": "exportEXCEL",

        "click .searchButton.add": "addLine",
        "click .searchButton.remove": "removeLine",
        "click #search": "submit",
        "change #fieldName": "adjustForm",
        "click .showMore": "showMore",
        "click #showAll": "showAll",
    },
    resumenCuentas: function(ev) {
        $(".reportButton").removeClass("btn-info").addClass("btn-default");
        this.type = "cuentas";
        this.report = "resumen_cuentas";
        $("#resumenCuentas").removeClass("btn-default").addClass("btn-info");
        $("#loaderContainer").show();
        // this.fetchModel(1);
        this.submit(ev);
    },
    resumenEpigraph: function(ev) {
        $(".reportButton").removeClass("btn-info").addClass("btn-default");
        this.type = "epigrafes";
        this.report = "resumen_epigrafe";
        $("#resumenEpigraph").removeClass("btn-default").addClass("btn-info");
        $("#loaderContainer").show();
        this.submit(ev);
    },
    resumenPatrimonio: function(ev) {
        $(".reportButton").removeClass("btn-info").addClass("btn-default");
        this.type = "epigrafes";
        this.report = "resumen_epigrafe";
        $("#detalleCuentas").removeClass("btn-default").addClass("btn-info");
        $("#loaderContainer").show();
        this.submit(ev);
    },
    detalleCuentas: function(ev) {

        $('#mainData').empty();

        $('#fieldName').html('');
        $('#fieldName').html('<option value="codigo">' + this.model.lang.CODIGO + '</option><option value="juridicos_naturaleza">' + this.model.lang.JURIDICOS_NATURALEZA + '</option>');
        $('#epigraphValue').hide();
        $('#codeValue').show();


        $('.searchButton').hide();


        $(".reportButton").removeClass("btn-info").addClass("btn-default");
        this.type = "cuentas";
        this.report = "detallado_cuentas";
        $("#detalleCuentas").removeClass("btn-default").addClass("btn-info");
        $("#loaderContainer").show();

        $("#btn_filters").removeClass("col-md-2").addClass("col-md-8");
        $("#fecha_show_oo").hide();
        $("#div_sea_filtre").show();
        this.submit(ev);
    },
    detalleEpigraph: function(ev) {

        $('#mainData').empty();


        $('#fieldName').html('');
        $('#fieldName').html('<option value="epigraph">' + this.model.lang.EPIGRAFE + '</option>');
        $('#epigraphValue').show();


        $(".reportButton").removeClass("btn-info").addClass("btn-default");
        this.type = "epigrafes";
        this.report = "detallado_epigrafe";
        $("#detalleEpigraph").removeClass("btn-default").addClass("btn-info");
        $("#loaderContainer").show();

        $("#btn_filters").removeClass("col-md-2").addClass("col-md-8");
        $("#fecha_show_oo").hide();
        $("#div_sea_filtre").show();

        this.submit(ev);
    },
    detallePatrimonio: function(ev) {
        $(".reportButton").removeClass("btn-info").addClass("btn-default");
        this.type = "epigrafes";
        this.report = "detallado_patrimonio";
        $("#detallePatrimonio").removeClass("btn-default").addClass("btn-info");
        $("#loaderContainer").show();
        this.submit(ev);
    },
    detalleAlta: function(ev) {

        $('#mainData').empty();

        $('.fecha_alta_fi').removeClass("none_vie");
        $('.fecha_baja_fi').addClass("none_vie");



        $(".reportButton").removeClass("btn-info").addClass("btn-default");
        this.type = "epigrafes";
        this.report = "detallado_altas";
        $("#detalleAlta").removeClass("btn-default").addClass("btn-info");
        $("#loaderContainer").show();

        $("#btn_filters").removeClass("col-md-8").addClass("col-md-2");
        $("#fecha_show_oo").show();
        $("#div_sea_filtre").hide();
        this.submit(ev);
    },
    detalleBaja: function(ev) {

        $('.fecha_alta_fi').addClass("none_vie");
        $('.fecha_baja_fi').removeClass("none_vie");

        $('#mainData').empty();


        $(".reportButton").removeClass("btn-info").addClass("btn-default");
        this.type = "epigrafes";
        this.report = "detallado_bajas";
        $("#detalleBaja").removeClass("btn-default").addClass("btn-info");
        $("#loaderContainer").show();

        $("#btn_filters").removeClass("col-md-8").addClass("col-md-2");
        $("#fecha_show_oo").show();
        $("#div_sea_filtre").hide();

        this.submit(ev);
    },
    exportPDF: function(ev) {
        ev.preventDefault();
        var thisAlias = this;
        var xhr = new XMLHttpRequest();
        // Si se ha aplicado un filtro, se hace la búsqueda tb para el pdf
        var method, url, data = [],
            request = {};
        if (thisAlias.filter) {
            method = "POST";
            url = "api/reports/index.php";
            $.each($(".formLine"), function() {
                if ($(this).find("#fieldName").val()) {
                    var line = {};
                    line.fieldName = $(this).find("#fieldName").val();
                    line.nbcomparador = $(this).find(".operator:visible").val();
                    line.value = $(this).find(".value:visible").val();
                    line.operator = $(this).find("#operator").val();
                    line.operator === "--" ? "" : line.operator;
                    data.push(line);
                }
            });
            request.instanceId = S.instanceId;
            request.data = data;
            request.page = 1;
            request.format = "pdf";
            request.type = thisAlias.type;
            request.report = thisAlias.report;

            request.date_start = $("#rangofechasStart").val();
            request.date_end = $("#rangofechasEnd").val();



        } else {
            method = "GET";
            url = "api/reports/index.php?instanceId=" + S.instanceId +
                "&page=1&report=" + thisAlias.report + "&format=pdf";
        }
        // Prepare call
        xhr.open(method, url, true);
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.setRequestHeader('Authorization', 'Bearer ' + S.token);
        xhr.responseType = 'arraybuffer';

        // Direct download
        $("#loaderContainer").show();
        xhr.onload = function(e) {
            if (this.status == 200) {
                var blob = new Blob([this.response], {
                    type: "application/pdf"
                });
                var link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = request.report + "_" + Moment().format('DD-MM-YYYY') + ".pdf";
                link.click();
            }
            $("#loaderContainer").hide();
        };
        xhr.send(JSON.stringify(request));

    },
    exportPDFDetail: function(ev) {
        ev.preventDefault();
        var thisAlias = this;
        var confirmTitle = S.userInfo.attributes.lang.GENERATE_PDF;
        bootbox.confirm(confirmTitle, function(response) {
            if (response) {

                // Deferred PDF
                var xhr = new XMLHttpRequest();
                // Si se ha aplicado un filtro, se hace la búsqueda tb para el pdf
                var method, url, data = [],
                    request = {};
                if (thisAlias.filter) {
                    method = "POST";
                    url = "api/reports/index.php";
                    $.each($(".formLine"), function() {
                        if ($(this).find("#fieldName").val()) {
                            var line = {};
                            line.fieldName = $(this).find("#fieldName").val();
                            line.nbcomparador = $(this).find(".operator:visible").val();
                            line.value = $(this).find(".value:visible").val();
                            line.operator = $(this).find("#operator").val();
                            line.operator === "--" ? "" : line.operator;
                            data.push(line);
                        }
                    });
                    request.instanceId = S.instanceId;
                    request.data = data;
                    request.page = 1;
                    request.format = "pdf";
                    request.type = thisAlias.type;
                    request.report = thisAlias.report;
                    S.report = thisAlias.report;

                    request.date_start = $("#rangofechasStart").val();
                    request.date_end = $("#rangofechasEnd").val();


                } else {
                    method = "GET";
                    url = "api/reports/index.php?instanceId=" + S.instanceId +
                        "&page=1&report=" + thisAlias.report + "&format=pdf";
                }
                // Prepare call
                xhr.open(method, url, true);
                xhr.setRequestHeader("Content-Type", "application/json");
                xhr.setRequestHeader('Authorization', 'Bearer ' + S.token);
                xhr.responseType = 'arraybuffer';

                // Deferred PDF generation                        
                $("#generatedPDF").addClass("hidden");
                $("#generatingPDF").removeClass("hidden");
                $('.exportPDFButton').addClass("hidden");
                $('#exportPDFDisabled').removeClass("hidden");
                S.mApp.trigger("startChecking");
                xhr.onload = function(e) {
                    if (this.status == 200) {

                    }
                };

                xhr.send(JSON.stringify(request));


            } else {
                return;
            }
        })


    },
    exportEXCEL: function(ev) {
        ev.preventDefault();



        // if( (this.report == "resumen_cuentas" ) || (this.report == "resumen_epigrafe") ){
        if (this.report) {

            $("#loaderContainer").show();

            var xhr = new XMLHttpRequest();
            // Si se ha aplicado un filtro, se hace la búsqueda tb para el excel
            var method, url, data = [],
                request = {};

            if (this.filter) {
                method = "POST";
                url = "api/reports/index.php";
                $.each($(".formLine"), function() {
                    if ($(this).find("#fieldName").val()) {
                        var line = {};
                        line.fieldName = $(this).find("#fieldName").val();
                        line.nbcomparador = $(this).find(".operator:visible").val();
                        line.value = $(this).find(".value:visible").val();
                        line.operator = $(this).find("#operator").val();
                        line.operator === "--" ? "" : line.operator;
                        data.push(line);
                    }
                });

                request.instanceId = S.instanceId;
                request.data = data;
                request.page = 1;
                request.format = "xls";
                request.type = this.type;
                request.report = this.report;

                request.date_start = $("#rangofechasStart").val();
                request.date_end = $("#rangofechasEnd").val();



            } else {
                method = "GET";
                url = "api/reports/index.php?instanceId=" + S.instanceId +
                    "&page=1&report=" + this.report + "&format=csv";
            }


            xhr.open(method, url, true);
            xhr.setRequestHeader("Content-Type", "application/json");
            xhr.setRequestHeader('Authorization', 'Bearer ' + S.token);
            xhr.responseType = 'arraybuffer';
            xhr.onload = function(e) {
                if (this.status == 200) {
                    var blob = new Blob([this.response], {
                        type: "data:application/vnd.ms-excel;charset=UTF-16LE"
                    });
                    var link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = request.report + "_" + Moment().format('DD-MM-YYYY') + ".csv";
                    link.click();
                }

                $("#loaderContainer").hide();
            };

            xhr.send(JSON.stringify(request));
        }
    },
    fetchModel: function(page, format) {
        this.model.fetch({
            data: {
                instanceId: S.instanceId,
                page: page,
                report: this.report,
                format: format
            },
            beforeSend: T.useToken
        });
    },
    adjustForm: function() {
        $(".formLine").each(function() {
            var selector = $(this).find("#fieldName");
            $(this).find("#operatorHolder select").hide();
            $(this).find("#valueHolder > *").hide();

            switch (selector.val()) {
                case "denominacion":

                    $(this).find("#nbIncluye").show();
                    $(this).find("#textValue").show();
                    break;
                case "epigraph":

                    $(this).find("#nbIgual").show();
                    $(this).find("#epigraphValue").show();
                    break;
                case "areaFuncional":

                    $(this).find("#nbIgual").show();
                    $(this).find("#areaValue").show();
                    break;
                case "juridicos_uso":

                    $(this).find("#nbIgual").show();
                    $(this).find("#usoValue").show();
                    break;
                case "juridicos_costeAdquisicion":
                    $(this).find("#nbcomparador").show();
                    $(this).find("#numberValue").show();
                    break;
                case "fechaAlta":
                    $(this).find("#nbcomparador").show();
                    $(this).find(".dateGroup").show();
                    break;
                case "codigo":
                    $(this).find("#nbIgual").show();
                    $(this).find("#codeValue").show();
                    break;
                case "juridicos_naturaleza":
                    $(this).find("#nbIgual").show();
                    $(this).find("#codeValuejuridicos").show();
                    break;

                case "entity":
                    $(this).find("#nbIgual").show();
                    $(this).find("#entitiesValue").show();
                    break;
                default:
                    $(this).find("#nbIgual").show();
                    $(this).find("#textValue").val("").show();

            }
        });
        //Date controls
        $(".dateGroup").datetimepicker({
            format: 'DD/MM/YYYY'
        });
    },
    addLine: function(ev) {
        var operator = $(ev.target).parents(".formLine").find("#operator");
        if (operator.val() === "--")
            operator.val("and");

        $("#lines").append(LineTpl({
            params: parametersModel.toJSON(),
            lang: this.model.lang,
            areas: S.areas
        }));

        //Date controls
        $(".dateGroup").datetimepicker({
            format: 'DD/MM/YYYY'
        });

        this.adjustForm();
    },
    removeLine: function(ev) {
        $(ev.target).parents(".formLine").remove();
    },
    submit: function(ev) {

        ev.preventDefault();

        if (!this.report) return;

        this.stopPendingPDF();

        this.filter = 1;
        $("#loaderContainer").show();

        var request = {};
        var data = [];
        $.each($(".formLine"), function() {
            if ($(this).find("#fieldName").val()) {
                var line = {};
                line.fieldName = $(this).find("#fieldName").val();
                line.nbcomparador = $(this).find(".operator:visible").val();
                line.value = $(this).find(".value:visible").val();
                line.operator = $(this).find("#operator").val();
                line.operator === "--" ? "" : line.operator;
                data.push(line);
            }
        });

        request.instanceId = S.instanceId;
        request.data = data;
        request.page = 1;
        request.type = this.type;
        request.report = this.report;
        request.date_start = $("#rangofechasStart").val();
        request.date_end = $("#rangofechasEnd").val();

        this.model.save(request, {
            beforeSend: T.useToken,
            success: function() {
                $("#loaderContainer").hide();
            }.bind(this)
        });
    },
    showMore: function(ev) {
        var icon = $(ev.target);
        if (icon.hasClass("glyphicon-plus")) {
            $(ev.target).parents("tbody").find("tr.hidden").removeClass("hidden");
            icon.removeClass("glyphicon-plus").addClass("glyphicon-minus");
        } else {
            $(ev.target).parents("tbody").find("tr.showable").addClass("hidden");
            icon.removeClass("glyphicon-minus").addClass("glyphicon-plus");
        }

    },
    showAll: function(ev) {
        var button = $(ev.currentTarget);
        var icon = button.find("span");
        if (icon.hasClass("glyphicon-plus")) {
            $("#mainData").find("tr.hidden").removeClass("hidden");
            icon.removeClass("glyphicon-plus").addClass("glyphicon-minus");
        } else {
            $("#mainData").find("tr.showable").addClass("hidden");
            icon.removeClass("glyphicon-minus").addClass("glyphicon-plus");
        }

    },
    stopPendingPDF: function() {

        if (this.report) {
            $('.exportPDFButton').removeClass("hidden");
            $('#exportPDFDisabled').addClass("hidden");
        }
    },
    regions: {
        regionData: "#regionData"
    }
});


//////////////////
// WEBPACK FOOTER
// ./app/views/report/reportView.js
// module id = 207
// module chunks = 0